const API_BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? '';

// With HttpOnly cookies, we don't store tokens client-side.
// The cookie is set by the server and sent automatically.
// We just need to detect if we're authenticated by calling /api/auth/me.

export async function refreshToken(): Promise<boolean> {
  try {
    const res = await fetch(`${API_BASE}/api/auth/refresh`, {
      method: 'POST',
      credentials: 'include',
    });
    return res.ok;
  } catch {
    return false;
  }
}

export async function logout(): Promise<void> {
  await fetch(`${API_BASE}/api/auth/logout`, {
    method: 'POST',
    credentials: 'include',
  }).catch(() => {});
}
